import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import DownloadPdfButton from "../components/DownloadPDFButton";
import { primaryShade1, red } from "../styles/color";
import moment from "moment";
import Slide from "@material-ui/core/Slide";
import Layout from "../layouts/Layout";
import Fab from "@material-ui/core/Fab";
import Loading from "./Loading";

let platform = "other";
if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}
const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class SaudaChitti extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      shareDialog: false,
      selectedDealId: null,
      selectedSellerName: null,
      selectedBuyerName: null,
      selectedRate: null,
      selectedDate: "",
      selectedProducts: null
    };
  }

  getDateValue = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();
    let dateMonthYear = date + "-" + month + "-" + year;
    return dateMonthYear;
  };

  render() {
    const {
      invoicePrintData,
      products,
      dealId,
      currentUser,
      sellerDetails,
      buyerDetails,
      deals,
      units
    } = this.props;
    const {} = this.state;
    return (
      <Layout
        position="static"
        bottomNavigation={false}
        appBar
        appBarTitle="Deal Preview"
        appBarLeftIcon={true}
        appBarRightIcon={true}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height:
              platform === "ios" ? window.innerHeight : "calc(100vh - 66px)",
            maxHeight: "calc(100vh - 66px)",
            justifyContent: "center",
            alignItems: "center",
            width: platform === "ios" ? "100%" : "100vw",
            position: "absolute",
            top: "66px"
          }}
        >
          {invoicePrintData.length > 0 ? (
            <div>
              <div
                className="printData"
                id={dealId}
                style={{
                  transform: "scale(0.6)",
                  display: "flex",
                  height: "842px",
                  width: "595px",
                  flexDirection: "column",
                  border: "1px solid black"
                }}
              >
                {currentUser.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      margin: "5px 5px 0px 5px",
                      alignItems: "center",
                      fontSize: "0.7em"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flex: [3],
                        justifyContent: "flex-start"
                      }}
                    >
                      <strong>
                        Email :{" "}
                        {currentUser[0].email ? currentUser[0].email : ""}
                      </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [3],
                        justifyContent: "center"
                      }}
                    >
                      <strong>SHRI</strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [3],
                        justifyContent: "flex-end"
                      }}
                    >
                      <strong>
                        Pan No :-{" "}
                        {currentUser[0].panNumber
                          ? currentUser[0].panNumber
                          : ""}
                      </strong>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "1.5em",
                    backgroundColor: "black",
                    color: "white",
                    margin: "0px 5px 5px 5px"
                  }}
                >
                  <strong>
                    {invoicePrintData[0].companyName
                      ? invoicePrintData[0].companyName
                      : "no data"}
                  </strong>
                </div>
                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid black",
                    margin: " 0px 5px 5px 5px",
                    justifyContent: "center",
                    justifyItems: "center",
                    flexDirection: "column",
                    fontSize: "0.9em",
                    height: platform === "ios" ? "130px" : null
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "center",
                      justifyItems: "center"
                    }}
                  >
                    <strong>
                      {invoicePrintData[0].companyAddress
                        ? invoicePrintData[0].companyAddress
                        : "no data"}
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "center",
                      justifyItems: "center"
                    }}
                  >
                    <strong>
                      {" "}
                      {invoicePrintData[0].stdCode
                        ? "Phone:(Off.) " + invoicePrintData[0].stdCode
                        : " "}{" "}
                      {invoicePrintData[0].offPhone1
                        ? " -, " + invoicePrintData[0].offPhone1
                        : ""}
                      {invoicePrintData[0].offPhone2
                        ? "," + invoicePrintData[0].offPhone2
                        : ""}
                      {invoicePrintData[0].stdCode
                        ? ", (Resi.) " + invoicePrintData[0].stdCode
                        : " "}{" "}
                      {invoicePrintData[0].residencePhone
                        ? " - " + invoicePrintData[0].residencePhone
                        : ""}{" "}
                      {invoicePrintData[0].stdCode
                        ? "Fax : " + invoicePrintData[0].stdCode
                        : ""}{" "}
                      {invoicePrintData[0].faxNumber
                        ? " - " + invoicePrintData[0].faxNumber
                        : " "}
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "center",
                      justifyItems: "center",
                      textDecoration: "underline"
                    }}
                  >
                    <strong>BROKERS IN</strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      justifyItems: "center"
                    }}
                  >
                    <strong>
                      Broker In :-{" "}
                      {products.length > 0 ? products.toString() : "Wait...."}
                    </strong>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    margin: window.cordova ? "0px 5px 0px 5px" : "5px",
                    alignItems: "baseline",
                    fontSize: "0.9em"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [3],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>S.No. :</strong>{" "}
                    {deals[0].serialNumber ? Number(deals[0].serialNumber) : ""}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      borderLeft: "1px solid black",
                      borderTop: "1px solid black",
                      borderRight: "3px solid black",
                      borderBottom: "3px solid black",
                      flex: [3],
                      justifyContent: "center"
                    }}
                  >
                    <strong style={{ padding: "5px" }}>CONTRACT FORM</strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [3],
                      justifyContent: "flex-end"
                    }}
                  >
                    <strong>Date :</strong>{" "}
                    {deals[0].date ? this.getDateValue(deals[0].date) : ""}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px 5px 0px 5px",
                    fontSize: "0.9em",
                    height: platform === "ios" ? "50px" : null
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [3],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>Copy : </strong> Seller/Buyer
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flex: [3],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      The Under Bargin is made by your order is being informed.
                    </strong>
                  </div>
                </div>
                <div
                  style={{
                    className: "customerDetails",
                    display: "flex",
                    flexDirection: "row",
                    margin: "0px 5px 5px 5px",
                    fontSize: "0.8em"
                  }}
                >
                  {sellerDetails.length > 0 ? (
                    <div
                      style={{
                        className: "SellerCustomerDetails",
                        display: "flex",
                        flex: [5],
                        justifyContent: "flex-start",
                        backgroundColor: "#fafafa",
                        flexDirection: "column",
                        border: "1px solid black"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>SELLER</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            wordWrap: "break-word",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].name ? sellerDetails[0].name : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>ADDRESS</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].address
                            ? sellerDetails[0].address
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>GST NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].gstNumber
                            ? sellerDetails[0].gstNumber
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>TIN NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].tinNumber
                            ? sellerDetails[0].tinNumber
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>MOBILE NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].phoneNumber
                            ? sellerDetails[0].phoneNumber
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>THROUGH</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {deals[0].sellerThrough ? deals[0].sellerThrough : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>PAN NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {sellerDetails[0].panNumber
                            ? sellerDetails[0].panNumber
                            : ""}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {buyerDetails.length > 0 ? (
                    <div
                      style={{
                        className: "BuyerCustomerDetails",
                        display: "flex",
                        flex: [5],
                        justifyContent: "flex-start",
                        backgroundColor: "#fafafa",
                        flexDirection: "column",
                        border: "1px solid black"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>BUYER</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            wordBreak: "break-all",
                            wordWrap: "break-word",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].name ? buyerDetails[0].name : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>ADDRESS</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].address
                            ? buyerDetails[0].address
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>GST NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].gstNumber
                            ? buyerDetails[0].gstNumber
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>TIN NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].tinNumber
                            ? buyerDetails[0].tinNumber
                            : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>MOBILE NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].phoneNumber
                            ? buyerDetails[0].phoneNumber
                            : ""}
                        </div>
                      </div>{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>THROUGH</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {deals[0].buyerThrough ? deals[0].buyerThrough : ""}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: [1.5],
                            backgroundColor: "#c0c0c0"
                          }}
                        >
                          <strong>PAN NO</strong>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: [3.5],
                            backgroundColor: "white",
                            fontSize: "0.9em"
                          }}
                        >
                          {" "}
                          {buyerDetails[0].panNumber
                            ? buyerDetails[0].panNumber
                            : ""}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {deals.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: window.cordova
                        ? "0px 5px 0px 5px"
                        : "5px 5px 0px 5px",
                      fontSize: "0.8em",
                      height: platform === "ios" ? "130px" : null
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        <strong>NAME OF GOODS :</strong>
                      </div>
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        {" "}
                        {deals[0].products ? deals[0].products : ""}
                      </div>
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        <strong>QUALITY :</strong>
                      </div>
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        {" "}
                        {deals[0].quality ? deals[0].quality : ""}
                      </div>
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        <strong>RATE : </strong>
                      </div>
                      <div STYLE={{ display: "flex", flex: [1.6] }}>
                        {" "}
                        {deals[0].rate ? deals[0].rate : ""}/- Per{" "}
                        {units.length > 0 ? units[0].unitName : ""}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <div style={{ display: "flex", flex: [5] }}>
                        <strong>QUANTITY :</strong>{" "}
                        {deals[0].quantity ? parseInt(deals[0].quantity) : ""}{" "}
                        {units.length > 0 ? units[0].unitName : ""}
                      </div>
                      <div style={{ display: "flex", flex: [5] }}>
                        <strong>NO OF TRUCK/TROLLA :</strong>{" "}
                        {deals[0].truckTrollaQuantity
                          ? deals[0].truckTrollaQuantity
                          : ""}{" "}
                        {deals[0].truckTrollaName
                          ? deals[0].truckTrollaName
                          : ""}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <div style={{ display: "flex", flex: [5] }}>
                        {/* <strong>WEIGHTMENT :</strong>Kanta Weight */}
                      </div>
                      <div style={{ display: "flex", flex: [5] }}>
                        <strong>BARDANA CONDITION :</strong>{" "}
                        {deals[0].bardanaCondition
                          ? deals[0].bardanaCondition
                          : ""}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1]
                      }}
                    >
                      <strong>DISPATCH FROM :</strong>{" "}
                      {sellerDetails[0].address ? sellerDetails[0].address : ""}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1]
                      }}
                    >
                      <strong>DISPATCH TO : </strong> As Per Buyer
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1]
                      }}
                    >
                      <strong>DISPATCH CONDITION :</strong>{" "}
                      {deals[0].dispatchCondition
                        ? deals[0].dispatchCondition
                        : ""}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <div style={{ display: "flex", flex: [5] }}>
                        <strong>BROKERAGE SELLER :</strong>{" "}
                        {deals[0].sellerBrokerage
                          ? parseInt(deals[0].sellerBrokerage)
                          : ""}
                      </div>
                      <div style={{ display: "flex", flex: [5] }}>
                        <strong>BROKERAGE BUYER :</strong>{" "}
                        {deals[0].buyerBrokerage
                          ? parseInt(deals[0].buyerBrokerage)
                          : ""}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px",
                    border: "1px solid black ",
                    fontSize: "0.9em",
                    height: platform === "ios" ? "30px" : null
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start",
                      backgroundColor: "#c0c0c0"
                    }}
                  >
                    <strong>
                      (Seller and Buyer will send us a duplicate Copy of Bills
                      and Payment respectively)
                    </strong>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "5px",
                    borderBottom: "1px solid black ",
                    fontSize: "0.9em",
                    height: window.cordova ? "105px" : ""
                  }}
                >
                  <div
                    id="row1"
                    style={{
                      disply: "flex",
                      flex: [5],
                      flexDirection: "column"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-start",
                        textDecoration: "underline"
                      }}
                    >
                      <strong>CONDITIONS :- </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-start"
                      }}
                    >
                      <strong>1.Freight will be buyer.</strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-start"
                      }}
                    >
                      <strong>
                        2.Advance payment in without cash discount.
                      </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-start"
                      }}
                    >
                      <strong>3.GST Nil.</strong>
                    </div>
                  </div>
                  <div
                    id="row2"
                    style={{
                      disply: "flex",
                      flex: [5],
                      flexDirection: "column"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-end"
                      }}
                    >
                      For :
                      <strong>
                        {" "}
                        {invoicePrintData[0].companyName
                          ? invoicePrintData[0].companyName
                          : "no data"}
                      </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: [1],
                        justifyContent: "flex-end",
                        margin: "5px 0px 5px 0px"
                      }}
                    >
                      Authorised Signatory
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    margin: "5px 5px 0px 5px",
                    alignItems: "center",
                    backgroundColor: "#c0c0c0",
                    fontSize: "0.9em"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start",
                      textDecoration: "underline",
                      marginTop: window.cordova ? "5px" : "0px"
                    }}
                  >
                    <strong>GENERAL TERMS & CONDITIONS : </strong>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    margin: "0px 5px 5px 5px",
                    paddingTop: "5px",
                    backgroundColor: "#c0c0c0",
                    flexDirection: "column",
                    fontSize: "0.7em"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      1. Our Brokerage & other charges are payable at Raipur
                      Buyer and Seller on demand without any deduction.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      2. Buyer and Seller should contact each other for
                      indent,delivery,payment,etc,after the bargain if made.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      3. Broker are not liable or any claims or dispute
                      whatsoever.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      4. Brokerage will be collected from seller if the bargain
                      is cancelled due to non supply on time and for all
                      settlements done for mom supply. In case of dispute
                      settlement made by arbitrators or brokerage in final.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      5. Seller will intimate this office and to Buyer, full
                      particular or dispatch with copies of bills,immediately
                      after goods dispatch Buyer shall intimate us and the
                      seller immediately after retiring hundi.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      6. Buyers send us "C" from along with payment.
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>7. Subject to Raipur Jurisdiction.</strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: [1],
                      justifyContent: "flex-start"
                    }}
                  >
                    <strong>
                      8. In case of bargain cancellation brokerage will be
                      charged.
                    </strong>
                  </div>
                </div>
                <div
                  id="termsFooter"
                  style={{
                    display: "flex",
                    flex: [1],
                    justifyContent: "space-between",
                    padding: 15
                  }}
                >
                  <div>Seller</div>
                  <div>Buyer</div>
                  <div>Broker</div>
                </div>
              </div>
            </div>
          ) : (
            <Loading />
          )}
          <div>
            <Fab
              aria-label="Add"
              style={{
                position: "fixed",
                bottom: "15px",
                right: "15px",
                backgroundColor: primaryShade1
              }}
            >
              <DownloadPdfButton
                invoiceId={dealId}
                invoiceNumber={"Deal_Detail"}
              />
            </Fab>
          </div>
        </div>
      </Layout>
    );
  }
}

export default withRouter(withStyles(styles)(SaudaChitti));
